import React from 'react'
import {
  BrowserRouter as Router,
  Routes as RouterRoutes,
  Route,
} from 'react-router-dom'
import Dashboard from './screens/Dashboard'
import { Login } from './screens/Login'
import './styles/login.scss'

const Routes = () => {
  return (
    <Router>
      <div className="app-container">
        <RouterRoutes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Dashboard />} />
        </RouterRoutes>
      </div>
    </Router>
  )
}

export default Routes
